import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import Header from './../Common/Header'
import Footer from './../Common/Footer'

const images = [
  require('./../../images/projects/portrait/pic7.jpg'),
  require('./../../images/projects/portrait/pic4.jpg'),
  require('./../../images/projects/portrait/pic5.jpg'),
  require('./../../images/projects/portrait/pic1.jpg')
]

const gallery = [
  require('./../../images/projects/portrait/pic7.jpg'),
  require('./../../images/projects/portrait/pic4.jpg'),
  require('./../../images/projects/portrait/pic5.jpg'),
  require('./../../images/projects/portrait/pic1.jpg'),
  require('./../../images/projects/portrait/pic6.jpg'),
  require('./../../images/projects/portrait/pic2.jpg')
]

const GreenwichReplica = () => {
  useEffect(()=>{
    // inject minimal styles scoped for this page
    const css = `
      .gr-hero{ min-height:68vh; display:flex; align-items:center; background-size:cover; background-position:center; position:relative; }
      .gr-hero .overlay{ position:absolute; left:0; right:0; top:0; bottom:0; background:rgba(0,0,0,0.45); }
      .gr-hero .hero-inner{ position:relative; z-index:2; }
      .gr-highlights .highlight-card{ border:0; box-shadow:0 6px 18px rgba(0,0,0,0.06); border-radius:8px; }
      .gr-highlights .highlight-card .icon{ height:68px; display:flex; align-items:center; justify-content:center; }
      .gr-highlights h3{ font-size:1.65rem; }
      .gr-amenities .amen-card{ text-align:center; padding:18px; border-radius:8px; transition:transform .18s ease; }
      .gr-amenities .amen-card:hover{ transform:translateY(-6px); }
      .gr-location .carousel-item img{ width:100%; height:320px; object-fit:cover; }
      .gr-gallery .card img{ height:180px; object-fit:cover; }
      .gr-specs .spec-block{ padding:18px; border-radius:6px; background:#f8f9fa; margin-bottom:12px; }
      @media(min-width:992px){ .gr-contact-sticky{ position:sticky; top:120px; } }
    `
    const style = document.createElement('style')
    style.id = 'gr-greenwich-styles'
    style.innerHTML = css
    document.head.appendChild(style)
    return ()=>{ const s = document.getElementById('gr-greenwich-styles'); if(s) s.remove() }
  },[])

  const handleEnquiry = (e)=>{
    e.preventDefault()
    const form = e.target
    const villaType = form.villatype.value
    alert(`Enquiry submitted for ${villaType} — we will contact you soon.`)
  }

  return (
    <>
      <Header />
      <main>
        {/* Navbar (anchor links) */}
        <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top">
          <div className="container">
            <NavLink className="navbar-brand" to="/">PBVR Soham Ville</NavLink>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#grNav" aria-controls="grNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="grNav">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item"><a className="nav-link" href="#highlights">Project Highlights</a></li>
                <li className="nav-item"><a className="nav-link" href="#amenities">Amenities</a></li>
                <li className="nav-item"><a className="nav-link" href="#floorplan">Floor Plan</a></li>
                <li className="nav-item"><a className="nav-link" href="#location">Location</a></li>
                <li className="nav-item"><a className="nav-link" href="#gallery">Gallery</a></li>
                <li className="nav-item"><a className="nav-link" href="#specs">Specifications</a></li>
              </ul>
            </div>
          </div>
        </nav>

        {/* Hero */}
        <section id="hero" className="gr-hero" style={{backgroundImage:`url(${images[0]})`}}>
          <div className="overlay" />
          <div className="container hero-inner text-white">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <h1 className="display-5">PBVR Soham Ville — Forest Weekend Luxury Villas</h1>
                <p className="lead">Discover pollution-free green living with premium villa plots, a grand clubhouse and curated amenities for wellness and leisure.</p>
              </div>
              <div className="col-lg-4 offset-lg-1">
                <div className="card shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title">Enquire Villa Type</h5>
                    <form onSubmit={handleEnquiry}>
                      <div className="mb-2">
                        <select name="villatype" className="form-select" defaultValue="4BHK">
                          <option>4BHK</option>
                          <option>6BHK</option>
                        </select>
                      </div>
                      <div className="d-grid">
                        <button className="btn btn-primary">Submit Enquiry</button>
                      </div>
                    </form>
                    <small className="text-muted d-block mt-2">Or call: 8977500219</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Project Highlights */}
        <section id="highlights" className="py-5 gr-highlights">
          <div className="container">
            <div className="row mb-4">
              <div className="col-12">
                <h2>Project Highlights</h2>
              </div>
            </div>
            <div className="row g-3">
              <div className="col-md-3">
                <div className="card highlight-card text-center p-3 h-100">
                  <div className="icon text-primary mb-2"><i className="fa fa-home fa-2x" /></div>
                  <h3 className="mb-0">3,671 - 7,917</h3>
                  <small className="d-block text-muted">SFT UNIT AREA</small>
                  <div className="mt-2 text-muted small">Pranava’s Greenwich villas Hyderabad Area</div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="card highlight-card text-center p-3 h-100">
                  <div className="icon text-success mb-2"><i className="fa fa-building fa-2x" /></div>
                  <h3 className="mb-0">20,000+</h3>
                  <small className="d-block text-muted">SFT CLUBHOUSE</small>
                  <div className="mt-2 text-muted small">Pranava’s Greenwich villas Hyderabad green clubhouse</div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="card highlight-card text-center p-3 h-100">
                  <div className="icon text-warning mb-2"><i className="fa fa-tree fa-2x" /></div>
                  <h3 className="mb-0">40</h3>
                  <small className="d-block text-muted">AMENITIES</small>
                  <div className="mt-2 text-muted small">Pranava’s Greenwich villas Green Amenities</div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="card highlight-card text-center p-3 h-100">
                  <div className="icon text-info mb-2"><i className="fa fa-map fa-2x" /></div>
                  <h3 className="mb-0">9.13</h3>
                  <small className="d-block text-muted">ACRES</small>
                  <div className="mt-2 text-muted small">Pranava’s Greenwich villas Hyderabad overall view</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Amenities */}
        <section id="amenities" className="py-5 gr-amenities bg-light">
          <div className="container">
            <div className="row mb-4">
              <div className="col-lg-8">
                <h2>Amenities</h2>
                <p>World-class amenities to support wellness, recreation, and community living.</p>
              </div>
            </div>
            <div className="row g-3">
              {[
                'Club House - 20,000 Sq.ft','Cycle Track','Outdoor Fitness Zone','Children\'s Play Area','Amphitheatre','Outdoor Play Area','Cricket Practising Pitch','Half Basketball Court','Pool Deck','Kid\'s Pool','Lap Pool','Reflexology Pathway','Meditation Area','Skating Rink','Senior Citizen Deck','Vegetable Garden','Herbal Garden','Community Farming'
              ].map((a,i)=> (
                <div className="col-md-3" key={i}>
                  <div className="amen-card p-3 h-100">
                    <div className="mb-2 text-primary"><i className="fa fa-check fa-2x" /></div>
                    <h6 className="mb-0">{a}</h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Location (carousel) */}
        <section id="location" className="py-5 gr-location">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <h2>Location & Nearby Landmarks</h2>
                <p>Conveniently located with easy access to key destinations.</p>

                <div id="locationCarousel" className="carousel slide" data-bs-ride="carousel">
                  <div className="carousel-inner">
                    {images.map((img, idx)=> (
                      <div className={`carousel-item ${idx===0? 'active':''}`} key={idx}>
                        <img src={img} className="d-block w-100" alt={`landmark-${idx}`} />
                        <div className="carousel-caption d-none d-md-block">
                          <h5>Landmark {idx+1}</h5>
                          <p>Distance: { (idx+1)*2 } km</p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <button className="carousel-control-prev" type="button" data-bs-target="#locationCarousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button className="carousel-control-next" type="button" data-bs-target="#locationCarousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>

              <div className="col-lg-4 gr-contact-sticky">
                <div className="card shadow-sm">
                  <div className="card-body">
                    <h5>Contact Sales</h5>
                    <p className="mb-1">Call: <a href="tel:8977500219">8977500219</a></p>
                    <p>Email: <a href="mailto:jmrgroup123@gmail.com">jmrgroup123@gmail.com</a></p>
                    <a href="#contact" className="btn btn-primary">Request Brochure</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Gallery */}
        <section id="gallery" className="py-5 gr-gallery">
          <div className="container">
            <h2>Gallery</h2>
            <div className="row g-3">
              {gallery.map((g, i)=> (
                <div className="col-md-4" key={i}>
                  <div className="card">
                    <img src={g} className="card-img-top" alt={`gallery-${i}`} />
                    <div className="card-body">
                      <h6 className="card-title">Project Image {i+1}</h6>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Specifications */}
        <section id="specs" className="py-5 gr-specs bg-light">
          <div className="container">
            <h2>Specifications</h2>
            <div className="row">
              <div className="col-md-6">
                <div className="spec-block">
                  <h6>Structure</h6>
                  <ul>
                    <li>RCC framed structure with earthquake resistant design</li>
                    <li>High strength concrete for foundations</li>
                    <li>Seismic zone compliant materials</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="spec-block">
                  <h6>Finishes</h6>
                  <ul>
                    <li>Premium vitrified tiles in living and dining</li>
                    <li>Anti-skid tiles in utility and terraces</li>
                    <li>Designer CP fittings and sanitary ware</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer CTA area for contact anchor */}
        <section id="contact" className="py-5">
          <div className="container">
            <h3>Get in touch</h3>
            <p>Write to us or call for more information.</p>
          </div>
        </section>

      </main>
      <Footer />
    </>
  )
}

export default GreenwichReplica;